import React from "react";
import { Menu, History, Clock } from "lucide-react";

import { Button } from "../../components/ui/button";

interface Props {
  value: number;
  dataLength: number;
  onChange: (value: number) => void;
}

const tabs = [
  { id: 0, label: "Menu", icon: Menu },
  { id: 1, label: "Anteriores", icon: History },
  { id: 2, label: "Próximas", icon: Clock },
];

export default function PanelNavigation({
  value,
  dataLength,
  onChange,
}: Props) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 border-t border-white/10 bg-slate-950/95 px-2 py-3 text-white backdrop-blur sm:px-4">
      <div className="mx-auto flex max-w-4xl items-center justify-between gap-1 sm:gap-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.id === value;
          return (
            <Button
              key={tab.id}
              variant={isActive ? "default" : "ghost"}
              className={
                isActive
                  ? "flex-1 bg-primary text-primary-foreground shadow-md"
                  : "flex-1 text-slate-400 hover:text-white hover:bg-white/5"
              }
              onClick={() => onChange(tab.id)}
            >
              <Icon className="h-4 w-4 sm:mr-2" />
              <span className="hidden text-sm font-semibold sm:inline">
                {tab.label}
              </span>
              {isActive && dataLength > 0 && tab.id !== 0 && (
                <span className="ml-1 rounded-full bg-slate-900/10 px-1.5 text-xs sm:ml-2 sm:px-2">
                  {dataLength}
                </span>
              )}
            </Button>
          );
        })}
      </div>
    </nav>
  );
}
